import { CheckableFieldComponent } from "./chunk-XZDF54SW.js";
import { Checkbox_default } from "./chunk-IEFRMYRN.js";
import { Icon_default } from "./chunk-BTGG6N6L.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/CheckboxField/CheckboxField.tsx
import React, { forwardRef } from "react";
import clsx from "clsx";
var CheckboxField = forwardRef((_a, ref) => {
  var _b = _a,
    {
      id,
      name,
      label,
      description,
      badge,
      secondaryAction,
      variant,
      validation,
      validationMessage,
      suffix,
      icon,
      className
    } = _b,
    rest = __objRest(_b, ["id", "name", "label", "description", "badge", "secondaryAction", "variant", "validation", "validationMessage", "suffix", "icon", "className"]);
  return /* @__PURE__ */React.createElement(CheckableFieldComponent, {
    id,
    name,
    label,
    description,
    badge,
    secondaryAction,
    variant: variant === "multiline" ? "primary" : variant,
    validation,
    validationMessage,
    className: clsx("pd-checkbox-field", variant === "multiline" && "pd-checkbox-field--multiline", className)
  }, /* @__PURE__ */React.createElement(CheckableFieldComponent.Input, __spreadValues({
    ref,
    as: Checkbox_default,
    className: "pd-checkbox-field__input"
  }, rest)), /* @__PURE__ */React.createElement(CheckableFieldComponent.Wrap, {
    className: "pd-checkbox-field__wrap"
  }, variant === "multiline" ? /* @__PURE__ */React.createElement(React.Fragment, null, /* @__PURE__ */React.createElement("div", {
    className: "pd-checkbox-field__wrap-inner"
  }, /* @__PURE__ */React.createElement(CheckableFieldComponent.Label, {
    className: "pd-checkbox-field__label"
  }), /* @__PURE__ */React.createElement(CheckableFieldComponent.SecondaryAction, {
    className: "pd-checkbox-field__secondary-action"
  }), /* @__PURE__ */React.createElement(CheckableFieldComponent.Badge, {
    className: "pd-checkbox-field__badge"
  }), /* @__PURE__ */React.createElement(CheckableFieldComponent.Validation, {
    className: "pd-checkbox-field__validation"
  }), /* @__PURE__ */React.createElement(CheckableFieldComponent.Description, {
    className: "pd-checkbox-field__description"
  })), icon && /* @__PURE__ */React.createElement(Icon_default, {
    icon,
    size: "xl"
  })) : /* @__PURE__ */React.createElement(React.Fragment, null, /* @__PURE__ */React.createElement(CheckableFieldComponent.Label, {
    className: "pd-checkbox-field__label"
  }), /* @__PURE__ */React.createElement(CheckableFieldComponent.Description, {
    className: "pd-checkbox-field__description"
  }), /* @__PURE__ */React.createElement(CheckableFieldComponent.SecondaryAction, {
    className: "pd-checkbox-field__secondary-action"
  }), /* @__PURE__ */React.createElement(CheckableFieldComponent.Badge, {
    className: "pd-checkbox-field__badge"
  }), /* @__PURE__ */React.createElement(CheckableFieldComponent.Validation, {
    className: "pd-checkbox-field__validation"
  }), suffix && /* @__PURE__ */React.createElement("span", {
    className: "pd-ml-auto"
  }, suffix))));
});
var CheckboxField_default = CheckboxField;
export { CheckboxField_default };